// App constants
export const APP_NAME = 'Shoots'
export const APP_VERSION = '1.0.0'

// API endpoints
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api'

// Main marketing site (getshoots.app), distinct from the web-app host
// (gathering.getshoots.app). Used by the payment-setup pages' "Back to Shoots"
// CTAs so they leave the SPA for the marketing site instead of dead-ending on
// the app host.
export const MARKETING_URL = 'https://getshoots.app'

// Local storage keys
export const STORAGE_KEYS = {
  THEME: 'shoots-theme',
  USER: 'shoots-user',
  TOKEN: 'shoots-token',
} as const

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  SETTINGS: '/settings',
} as const
